import { AsyncActionState } from "../../../utils/asyncAction";
import * as types from "../../../actions/property/chain";

export const setUpdateChainStatus = (status: AsyncActionState) => {
    return {
        type: types.PropertyNotesTypes.UPDATE_CHAIN_STATUS,
        payload: status
    } as types.UpdateChainStatus;
};
